export var VERSION = '1.13.10';
//# sourceMappingURL=version.js.map